import { useState } from 'react';
import { api } from '../lib/api.js';

export const CHARS = [
  { id: 'king', name: 'กษัตริย์', src: '/assets/thai_char.png' },
  { id: 'friend1', name: 'แม่หญิงมาลี', src: '/assets/characters/friend1.png' },
  { id: 'friend2', name: 'หนุ่มเรือ', src: '/assets/characters/friend2.png' },
  { id: 'friend3', name: 'คุณนายทอง', src: '/assets/characters/friend3.png' },
  { id: 'friend4', name: 'นายพราน', src: '/assets/characters/friend4.png' },
  { id: 'friend5', name: 'หนุมาน', src: '/assets/characters/friend5.png' },
];
export const charById = (id) => CHARS.find((c) => c.id === id) || CHARS[0];

export default function CharacterSelect({ auth, current, onClose, onSelect }) {
  const [sel, setSel] = useState(current || 'king');
  const [busy, setBusy] = useState(false);

  async function save() {
    setBusy(true);
    try {
      await api('setChar', { ...auth, char: sel });
      onSelect(sel);
      onClose();
    } catch (e) { alert(e.message); } finally { setBusy(false); }
  }

  return (
    <div className="arrival" onClick={onClose}>
      <div className="arrival-card charsel" onClick={(e) => e.stopPropagation()}>
        <p className="ar-badge">🎭 เลือกตัวเดินของคุณ</p>
        <h2 className="ar-name">ตัวละคร</h2>
        <div className="char-grid">
          {CHARS.map((c) => (
            <button key={c.id} className={`char-opt ${sel === c.id ? 'on' : ''}`} onClick={() => setSel(c.id)}>
              <img src={c.src} alt={c.name} />
              <span>{c.name}</span>
            </button>
          ))}
        </div>
        <button className="btn" disabled={busy} onClick={save}>
          {busy ? 'กำลังบันทึก…' : 'เลือกตัวนี้!'}
        </button>
      </div>
    </div>
  );
}
